<template lang="pug">
v-flex#template-editor(sm12 md7)
  .overline.mb-2 Template

  template(v-if="componentTemplate")
    template-previewer.inline-preview(v-if="!showTemplateManager" :game="activeGame" :component="activeComponent" @open-template-manager="showTemplateManager = true")

  template(v-else)
    p.caption.grey--text.mb-2 This component does not have a Template set.

    template(v-if="componentSource")
      v-btn(small color="primary" @click="showTemplateManager = true") Set a Template...

    template(v-else)
      p.caption.grey--text You need to link a Spreadsheet before setting up a Template.

  v-dialog(v-model="showTemplateManager")
    template-manager(:component="component" @close-dialog="shutdownTemplateManager()")
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import TemplateManager from './TemplateManager.vue'
  import TemplatePreviewer from './TemplatePreviewer.vue'

  export default {
    props: ["component"],

    components: { TemplateManager, TemplatePreviewer },

    data() {
      return {
        showTemplateManager: false
      }
    },

    computed: {
      ...mapGetters([
        "activeGame",
        "activeComponent",
        "findComponentSheet",
        "findComponentTemplate"
      ]),

      componentSource() { return this.findComponentSheet(this.component) },

      componentTemplate() { return this.findComponentTemplate(this.component) }
    },

    methods: {
      ...mapActions(["clearActiveLayer"]),

      shutdownTemplateManager() {
        this.showTemplateManager = false
        this.$nextTick(() => {
          this.clearActiveLayer()
        })
      }
    }
  }
</script>
